/*
  GA4 Analytics — page views & custom events
  Measurement ID: G-09CJ7T8RDX
*/

const GA_ID = 'G-09CJ7T8RDX';

function gtag() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...arguments);
  }
}

/** SPA page view — call on every route change */
export function trackPageView(path) {
  gtag('config', GA_ID, { page_path: path });
}

/** Custom event */
export function trackEvent(eventName, params = {}) {
  gtag('event', eventName, params);
}

/* ── Pre-defined events ── */

export function trackTestStart(testSlug) {
  trackEvent('test_start', { test_name: testSlug });
}

export function trackTestComplete(testSlug, score, riskLevel) {
  trackEvent('test_complete', { test_name: testSlug, score, risk_level: riskLevel });
}

export function trackSignup() {
  trackEvent('signup', { method: 'email' });
}

export function trackAIView() {
  trackEvent('ai_view');
}

export function trackPremiumClick(source) {
  trackEvent('premium_click', { source });
}

export function trackPaymentStart() {
  trackEvent('payment_start');
}
